module.exports = __webpack_public_path__ + "img/admin-capture-setting.f869c7b7.png";